import React from "react";

interface InputTextFieldProps {
  value: string | number | undefined;
  onChange: any;
  label: string;
  placeholder?: string;
}

const TextField = ({
  value,
  onChange,
  label,
  placeholder
}: InputTextFieldProps) => {
  return (
    <label className="flex flex-col flex-grow max-w-full">
      <p className={placeholder && "sr-only"}>{label}</p>
      <input
        className="bg-black/20 border-b p-2 focus:outline-none focus:ring-yellow-200/60 focus:ring-2 focus:ring-inset focus:border-yellow-200/60"
        type="text"
        // @ts-ignore
        virtualKeyboardPolicy="manual"
        value={value || ""}
        onChange={onChange}
        placeholder={placeholder || ""}
      />
    </label>
  );
};

export default TextField;
